import { useState } from "react";
import "./style/FloatingInput.css";

export default function FloatingInput({ label, value, onChange, icon }) {
  const hasValue = value && value.length > 0;

  return (
    <div className="floating-input-wrapper">
      <label className={`floating-label ${hasValue ? "active" : ""}`}>
        {label}
      </label>

      <input
        className={`floating-input ${hasValue ? "with-label" : ""} ${icon ? "with-icon" : ""}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />

      {icon && <img src={icon} alt="icon" className="input-icon" />}
    </div>
  );
}

